
import { AclRoleLevel } from '../enums';

export const AclRoleLevels = [
  { name: 'App', value: AclRoleLevel.App },
  { name: 'Organization', value: AclRoleLevel.Environment },
];
